/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-bind */
import {ConfigProvider, App as AntdApp} from '@baidu/qianfan-antd-kit';
import {zhCN, en_US as enUS} from '@baidu/qianfan-antd-kit/locale';
import {message} from 'antd';
import {StyleProvider} from '@ant-design/cssinjs';
import VConsole from 'vconsole';
import {Cookies} from 'react-cookie';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import utc from 'dayjs/plugin/utc';
import {useEffect} from 'react';
import RouterIndex from '@/links/route';
import {initI18n} from '@/utils/i18n';
import {isLoadByIframe, isSandbox} from '@/utils/util';
import {useFramework} from '@/entries/share';
import EscapeAntd from '@/utils/escapeAntd';
import {COLOR_HOVER_PRIMARY, COLOR_PRIMARY} from '@/styles/common';

dayjs.locale('zh-cn');
dayjs.extend(utc);

function initVConsole() {
    if (isSandbox() && !isLoadByIframe()) {
        return new VConsole();
    }
}

export const cookies = new Cookies();

export const IFRAME_CLASS_NAME = 'load-by-iframe';
export const CONSOLE_QUALIFY_ROOT = 'console-qualify-root';

const borderColors = {
    activeBorderColor: COLOR_PRIMARY,
    hoverBorderColor: COLOR_HOVER_PRIMARY,
};


const App = () => {
    const framework = useFramework();
    const iframe = isLoadByIframe();
    initI18n(framework);
    initVConsole();
    const locale = framework?.locale === 'en-us' ? enUS : zhCN;

    useEffect(() => {
        const classList = [CONSOLE_QUALIFY_ROOT];
        if (iframe) {
            classList.push(IFRAME_CLASS_NAME);
        }

        const body = document.body;
        body.classList.add(...classList);

        return () => {
            body.classList.remove(...classList);
        };
    }, [iframe]);

    iframe && message.config({
        top: 200,
    });

    return (
        <ConfigProvider
            locale={locale}
            theme={{
                token: {
                    colorPrimaryActive: COLOR_PRIMARY,
                    colorPrimaryHover: COLOR_HOVER_PRIMARY,
                    borderRadius: 4,
                },
                components: {
                    Input: {
                        ...borderColors,
                        activeShadow: '0 0 0 2px rgba(5, 88, 255, 0.06)',
                    },
                    Select: borderColors,
                },
            }}
        >
            <StyleProvider>
                <AntdApp>
                    <EscapeAntd />
                    <RouterIndex />
                </AntdApp>
            </StyleProvider>
        </ConfigProvider>
    );
};

export default App;
